'use strict'
module.exports = {
  count: 1,
  passengers: [
    {
      type: 'ADT'
    }
  ],
  startDate: '2019-07-20',
  destinationToSearch: {
    city: ['-395224']
  },
  minHotelCategory: 3,
  minBoardType: 'no_board',
  minHotelRating: 80,
  refundable: null
}
